const showLoginOrResetPassword = () => {
  const hash = window.location.hash;

  if (hash) {
    const hashElement = document.querySelector(hash);

    if (hashElement) {
      const body = document.querySelectorAll('.auth__body');

      if (body && body.length) {
        body.forEach(el => {
          el.hidden = true;
        });
      }

      hashElement.hidden = false;
    }
  }
}
showLoginOrResetPassword();

window.addEventListener('popstate', () => {
  showLoginOrResetPassword();
});